
import {
  API_FEED_META_LIST_REQUEST,
  API_FEED_META_LIST_RECEIVE_SUCCESS,
  API_FEED_META_LIST_RECEIVE_FAILURE,
  API_FEED_REQUEST,
  API_FEED_RECEIVE_SUCCESS,
  API_FEED_RECEIVE_FAILURE
} from '../action_types.js';

export default (state = {}, action)=> {

  switch (action.type) {

  case API_FEED_META_LIST_REQUEST:
  case API_FEED_REQUEST:
    return {
      ...state,
      isLoading: true
    };

  case API_FEED_META_LIST_RECEIVE_FAILURE:
  case API_FEED_RECEIVE_FAILURE:
    return {
      ...state,
      isLoading: false,
      error: true
    };

  case API_FEED_META_LIST_RECEIVE_SUCCESS: 
    return {
      ...state,
      isLoading: false,
      apiFeedById: action.apiFeedById,
      error: false
    };

  case API_FEED_RECEIVE_SUCCESS:
    return {
      ...state,
      isLoading: false,
      apiFeedById: {
        ...state.apiFeedById,
        [action.data.id]: action.data
      },
      error: false
    }

  default:
    return state;
  }
}

export const getIsLoadingApiFeeds = (state)=>
  state.isLoading;


export const getApiFeedById = (state)=>
  state.apiFeedById || {};

export const getApiFeedForId = (state, id)=>
  getApiFeedById(state)[id];